import React from 'react';

export const ErrorIcon = () => (
  <div className="relative w-6 h-6 flex items-center justify-center">
    <div className="absolute inset-0 bg-gradient-to-b from-[#FA8059] to-[#E23B06] rounded-lg shadow-lg" style={{ boxShadow: '0px 0px 24px -4px rgba(248, 65, 7, 0.12), 0px 0px 16px -4px rgba(248, 65, 7, 0.08), 0px 0px 8px -6px rgba(248, 65, 7, 0.04)' }}></div>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="relative">
      <path d="M12.0007 9.33398V12.0007M12.0007 14.6673H12.0073M18.6673 12.0007C18.6673 15.6825 15.6825 18.6673 12.0007 18.6673C8.31882 18.6673 5.33398 15.6825 5.33398 12.0007C5.33398 8.31882 8.31882 5.33398 12.0007 5.33398C15.6825 5.33398 18.6673 8.31882 18.6673 12.0007Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);
